import React from 'react'

const RadioButtonInput = field =>
  <label htmlFor={field.value}>
    <input
      {...field.input}
      id={field.value}
      type={field.type}
      disabled={field.disabled}
      className="form-check-input"
      checked={field.selected}
    />
    {/* {field.meta.touched &&
      field.meta.error &&
      <span className={classes.error}>{field.meta.error}</span>} */}
    <span style={field.labelSpanStyle} className={field.lbelLengthStyel}>{field.label}</span>
  </label>

export default RadioButtonInput



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/RadioButtonInput/RadioButtonInput.jsx